import { routePaths } from '@apps/admin/route.paths';
import { useRouteMatch, useRouterHelper } from '@shared/core';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';

export type GuestStaysCanvasMode = Readonly<{
  // Flag on AND the Bookings tab is the visible tab. Drives the editor's full-canvas layout.
  isCanvasMode: boolean;
  // True while checking the flag, preventing premature canvas layout changes.
  isFlagLoading: boolean;
  // Flag resolved on. `BookingsTab` swaps its body on this.
  isDashboardEnabled: boolean;
}>;

// Checks if the dashboard flag is on and the exact Accommodations Bookings route is active.
export const useGuestStaysCanvasMode = (): GuestStaysCanvasMode => {
  const [isDashboardEnabled, isFlagLoading] = useIsFeatureEnabled('guestStaysDashboard');
  const router = useRouterHelper();
  const isBookingsRoute = !!useRouteMatch({ path: router.buildPath(routePaths.guestHotelBookings.path), exact: true });

  return {
    isFlagLoading,
    isDashboardEnabled,
    isCanvasMode: isDashboardEnabled && isBookingsRoute,
  };
};
